export const EDIT_ALLOWED_STATUSES = [
  'opened',
  'pending',
  'unassigned',
  'unfilled',
  'assigned',
  'inprogress',
  'completed',
  'canceled',
  'reassigned',
  'expired',
];
export const UNASSIGN_ALLOWED_STATUSES = ['assigned', 'reassigned', 'opened'];
export const CANCEL_ALLOWED_STATUSES = ['reassigned', 'assigned', 'unassigned', 'pending', 'unfilled', 'inprogress'];
export const DELETE_ALLOWED_STATUSES = ['opened'];
